import React, { memo, Dispatch, SetStateAction } from "react";
import { DialogDetails, DialogInfoField } from "components/shared";
import { Grid, Divider } from "@material-ui/core";
import { IAddressee } from "config/interfaces";

interface AddreeseeDetailsProps {
  order: IAddressee.Addressee;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

function AddreeseeDetails({ order, open, setOpen }: AddreeseeDetailsProps) {
  // console.log('order', order)
  const Accessible = (
    <p style={{ textTransform: "initial" }}>
      Destinatário prefere receber suas encomendas em boxes posicionados entre
      0,40m a 1,20m de altura?
      <strong style={{ marginLeft: "8px" }}>
        {order.FLCADEIRANTE ? "SIM" : "NÃO"}
      </strong>
    </p>
  );

  const isAccessible = (
    <p style={{ textTransform: "initial" }}>
      Na ausência de boxes acessíveis aceito receber encomendas em boxes comuns?
      <strong style={{ marginLeft: "8px" }}>
        {order.FLRECEIVEINCOMMONBOXES ? "SIM" : "NÃO"}
      </strong>
    </p>
  );
  const adresses = order?.GRUPOUSUARIO?.map((group) => group.ENDERECO).flat();

  const Content = (
    <Grid container spacing={2}>
      <Grid item container spacing={2}>
        <DialogInfoField
          item
          xs={12}
          sm={6}
          lg={3}
          title="NOME DO DESTINATÁRIO"
          value={order.NMUSUARIO}
        />
        <DialogInfoField item xs={12} sm={6} lg={3} title="" value="" />
        <DialogInfoField
          item
          xs={12}
          sm={6}
          lg={3}
          title="TELEFONE"
          value={order.TELEFONE}
        />
        {/* <DialogInfoField item xs={12} sm={6} lg={3} title="CPF" value={order.CPF} /> */}
      </Grid>

      <Divider style={{ width: "100%", margin: "8px 0" }} />

      {adresses?.map((address) => (
        <Grid item container spacing={2} key={address.IDENDERECO}>
          <DialogInfoField
            item
            xs={12}
            sm={6}
            lg={3}
            title="INSTALAÇÃO"
            value={address?.DSMCM ?? ""}
          />

          {address.ENDECOMPL.map((end, index) => {
            return (
              <DialogInfoField
                key={index}
                item
                xs={12}
                sm={6}
                lg={3}
                title={end.DSCOMPLEMENTO ?? ""}
                value={end.VLCOMPLEMENTO}
              />
            );
          })}
        </Grid>
      ))}

      <Divider style={{ width: "100%", margin: "8px 0" }} />

      <Grid item container spacing={2}>
        <DialogInfoField
          item
          xs={12}
          title="ACESSIBILIDADE"
          value={Accessible}
          icon="accessible"
        />
      </Grid>
      <Grid item container spacing={2}>
        <DialogInfoField item xs={12} title="" value={isAccessible} />
      </Grid>
    </Grid>
  );

  return (
    <DialogDetails
      title="Informações do Destinatário"
      open={open}
      setOpen={setOpen}
      content={Content}
    />
  );
}

export default memo(AddreeseeDetails);
